module.exports = "https://static.energy5.com/_next/static/images/highlightDecore-64f3b1e2c05a96032499fefec0a8445a.png";